import React, { useCallback, useEffect, useState } from 'react';
import { Row, Typography } from 'antd';
import { Dispatch } from "redux";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import SmartTable from '../../components/SmartTable';
import { resetHeader, setHeader } from '../../store/main';
import headerConfigs from '../../services/headerConfig';
import { getPaymentsTranastion, getPaymentsTranastionTotoal } from '../../store/payments';
import { is } from '../../services/helpers';
import { resetUsersState } from '../../store/users/UsersServices';

const { Text, Title } = Typography;

const columns = [
  {
    title: 'Date',
    dataIndex: 'created_at',
    key: 'created_at',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    defaultSortOrder: 'descend',
  },
  {
    title: 'Client',
    dataIndex: 'payer-name',
    key: 'payer-name',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Client Email',
    dataIndex: 'payer-email',
    key: 'payer-email',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Description',
    dataIndex: 'type',
    key: 'type',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Artist',
    dataIndex: 'receiver-name',
    key: 'receiver-name',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Artist Email',
    dataIndex: 'receiver-email',
    key: 'receiver-email',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Revenue',
    dataIndex: 'amount',
    key: 'amount',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
  {
    title: 'Commission',
    dataIndex: 'our_commission',
    key: 'our_commission',
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
  },
];

const Payment = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const paymentsData = useSelector((state: any) => state.payments.paymentsData);
  const page = useSelector((state: any) => state.payments.page);
  const lastPage = useSelector((state: any) => state.payments.lastPage);
  const status = useSelector((state: any) => state.payments.status);
  const paymentsTotal = useSelector((state: any) => state.payments.paymentsTotal);
  const date = useSelector((state: any) => state.payments.paymentsDate);
  const [data, setData] = useState<any>([]);
  const [tableData, setTableData] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getParams = () => {
    let params: any = {};
    params = {
      'filter[type]': 'subscription,tip',
    };

    return params;
  };

  useEffect(() => {
    dispatch(setHeader(headerConfigs.payments()));

    return () => {
      dispatch(resetUsersState());
      dispatch(resetHeader());
    };
  }, [dispatch]);

  useEffect(() => {
    let newData: any = [];
    paymentsData && paymentsData?.forEach((obj: any) => {
      newData.push({
        created_at: moment(obj?.created_at).format('L'),
        'payer-name': obj?.payer?.name,
        'payer-email': obj?.payer?.email,
        type: obj?.type,
        'receiver-name': obj?.receiver?.name,
        'receiver-email': obj?.receiver?.email,
        amount: `₪ ${obj?.amount}`,
        our_commission: `₪ ${obj?.our_commission}`,
      });
    });
    setData(newData);
  }, [paymentsData, dispatch, status]);
  
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [paymentsData]);

  const loadMoreData = useCallback(() => {
    if(page !== lastPage){
      setIsLoading(true)
    }

    let params = getParams();
    if (page === lastPage) return;
    if ((date?.start?.length > 0 && date?.end?.length > 0) || (tableData.order && tableData.field)) {
      params['page'] = page + 1;
      setIsLoading(true);
      if (tableData.order !== undefined) {
        params['sort'] = tableData.order === "ascend" ? tableData.field : ("-" + tableData.field);
      }
      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
      dispatch(getPaymentsTranastion(params));
    } else {
      params['page'] = page + 1;
      dispatch(getPaymentsTranastion(params));
    }
  }, [dispatch, page, tableData.order, tableData.field, date.start, date.end, lastPage]);

  useEffect(() => {
    let params = getParams();
    if (date?.start?.length > 0 && date?.end?.length > 0) {
      if (tableData.order !== undefined) {
        params['sort'] = tableData.order === "ascend" ? tableData.field : ("-" + tableData.field);
      }
      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
    }
    if (tableData.order !== undefined) {
      params['sort'] = tableData.order === "ascend" ? tableData.field : ("-" + tableData.field);
    }
    dispatch(getPaymentsTranastionTotoal(params));
    dispatch(getPaymentsTranastion(params));
  }, [date.start, date.end, dispatch, tableData]);

  return (
    <div className="payments-container">
      <SmartTable
        columns={columns}
        dataSource={data && data}
        pagination={false}
        onFetch={loadMoreData}
        onChange={(e: any, a: any, sort: any, d: any) => {
          setTableData(sort);
          setIsLoading(true)
        }}
        loading={isLoading}
      />
      <Row className="payments-sum">
        <Row className="payments-total-card" style={{ marginRight: "24px" }}>
          <Title level={5}>Total</Title>
          <Row style={{ alignItems: "center", paddingRight: "12px" }}>
            <Text className="payments-card-title">Revenue</Text>
            <Text className="dot"></Text>
            <Text className="payments-card-sum">{`₪ ${paymentsTotal?.amount ? parseFloat(paymentsTotal?.amount)?.toFixed(2) : 0}`}</Text>
          </Row>
        </Row>
        <Row className="payments-total-card">
          <Title level={5}>Total</Title>
          <Row style={{ alignItems: "center", paddingRight: "12px" }}>
            <Text className="payments-card-title">Commission</Text>
            <Text className="dot"></Text>
            <Text className="payments-card-sum">{`₪ ${paymentsTotal?.our_commission ? parseFloat(paymentsTotal?.our_commission)?.toFixed(2) : 0}`}</Text>
          </Row>
        </Row>
      </Row>
    </div>
  );
};

export default Payment;
